import common from '@/lib/common';

const appFdmApis = JSON.parse(process.env.VUE_APP_FDM_API);
const appOidcConfig = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
const baseUrls = JSON.parse(process.env.VUE_APP_BASE_URLS);
const app = JSON.parse(process.env.VUE_APP_CONFIG);

const AppConsts = {
    userManagement: {
        defaultAdminUserName: 'admin'
    },
    localization: {
        defaultLocalizationSourceName: 'Feedeem',
        shopLocalizationSourceName: 'FeedeemShop'
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token',
        homeUri: appOidcConfig.post_logout_redirect_uri,
        authority: appOidcConfig.authority
    },
    appBaseUrl: "http://localhost:8013",
    remoteServiceBaseUrl: appFdmApis.api,
    apis: appFdmApis,
    frontEndBaseUrl: baseUrls.frontEndBaseUrl,
    backEndBaseUrl: baseUrls.backEndBaseUrl,
    // tenant: app.tenant,
    // tenantId: app.tenant.id,
    // tenantName: app.tenant.name,
    tenancyName: app.tenancyName,
    appName: app.appName,
    user: app.user,
    weixin: app.weixin,
    alipay: app.alipay,
    meta: app.meta,
    fuyouOrderNoPrefix: '3695'
}

export default AppConsts